var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"taskProcess"},[(_vm.isQueue)?[_c('prePage')]:[_c('processAnimate',{on:{"revoke":_vm.revoke}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }